import { HttpResponse, makeRequest } from './index';
import {
	AssignCaseToComplaintRequest,
	AssignCaseToComplaintResponse,
	HistoryEntryResponse,
	ComplaintNotResponsibleRequest,
	ComplaintPublicResponse,
	ComplaintResponse,
	ComplaintsResponse,
	ConfirmComplaintRequest,
	CreateCaseFromComplaintRequest,
	CreateCaseFromComplaintResponse,
	CreateComplaintResponse,
} from '../types/types';
import { ComplaintRequest, SaveComplaintRequest } from '../types/formdataTypes';

const endpoint = 'Complaint';

export const getComplaint = async (id: string): Promise<HttpResponse<ComplaintResponse>> => {
	const result = await makeRequest<string, ComplaintResponse>(`${endpoint}?complaintId=${id}`, null, 'get');
	return result;
};

export const getPublicComplaint = async (id: string, token: string): Promise<HttpResponse<ComplaintPublicResponse>> => {
	const result = await makeRequest<string, ComplaintPublicResponse>(
		`${endpoint}/public?complaintId=${id}&emailToken=${token ? token : ''}`,
		null,
		'get',
	);
	return result;
};

export const createComplaint = async (request: ComplaintRequest) => {
	const formData = new FormData();
	if (request.gender) formData.append('gender', request.gender);
	formData.append('firstName', request.firstName);
	formData.append('lastName', request.lastName);
	formData.append('email', request.email);
	if (request.company) formData.append('company', request.company);
	if (request.phone) formData.append('phone', request.phone);
	formData.append('category', JSON.stringify(request.category));
	formData.append('title', request.title);
	formData.append('text', request.text);
	formData.append('medium', JSON.stringify(request.medium));
	if (request.createdDate) formData.append('createdDate', request.createdDate);
	if (request.files) {
		request.files.forEach((file, index) => {
			formData.append(`files[${index}]`, file.bytes, file.fileName);
		});
	}
	if (request.links) {
		formData.append('links', JSON.stringify(request.links));
	}
	if (request.internalNote) {
		formData.append('internalNote', request.internalNote);
	}

	const result = await makeRequest<any, CreateComplaintResponse>(`${endpoint}`, formData, 'post', true);
	return result;
};

export const saveComplaint = async (request: SaveComplaintRequest) => {
	const formData = new FormData();
	formData.append('complaintId', request.complaintId);
	if (request.category) formData.append('category', JSON.stringify(request.category));
	if (request.medium) formData.append('medium', JSON.stringify(request.medium));
	if (request.text) formData.append('text', request.text);
	if (request.files) {
		request.files.forEach((file, index) => {
			formData.append(`files[${index}]`, file.bytes, file.fileName);
		});
	}
	if (request.links) {
		formData.append('links', JSON.stringify(request.links));
	}
	if (request.internalNote) {
		formData.append('internalNote', request.internalNote);
	}
	if (request.publishedDate) {
		formData.append('publishedDate', request.publishedDate);
	}

	const result = await makeRequest<any, null>(`${endpoint}`, formData, 'put', true);
	return result;
};

export const deleteComplaint = async (id: string) => {
	const result = await makeRequest<string, null>(`${endpoint}?complaintId=${id}`, null, 'delete');
	return result;
};

export const confirmComplaint = async (request: ConfirmComplaintRequest) => {
	const result = await makeRequest<ConfirmComplaintRequest, null>(`${endpoint}/confirm`, request, 'post');
	return result;
};

export const assignCaseToComplaint = async (request: AssignCaseToComplaintRequest): Promise<HttpResponse<AssignCaseToComplaintResponse>> => {
	const result = await makeRequest<AssignCaseToComplaintRequest, AssignCaseToComplaintResponse>(`${endpoint}/assign_case`, request, 'post');
	return result;
};

export const createCaseFromComplaint = async (request: CreateCaseFromComplaintRequest): Promise<HttpResponse<CreateCaseFromComplaintResponse>> => {
	const result = await makeRequest<CreateCaseFromComplaintRequest, CreateCaseFromComplaintResponse>(`${endpoint}/create_case`, request, 'post');
	return result;
};

export const complaintNotResponsible = async (request: ComplaintNotResponsibleRequest) => {
	const result = await makeRequest<ComplaintNotResponsibleRequest, string>(`${endpoint}/not_responsible`, request, 'put');
	return result;
};

export const getComplaintLogs = async (id: string): Promise<HttpResponse<HistoryEntryResponse[]>> => {
	const result = await makeRequest<string, HistoryEntryResponse[]>(`${endpoint}/history?complaintId=${id}`, null, 'get', false, false);
	return result;
};

export const publishComplaint = async (id: string) => {
	const result = await makeRequest<string, null>(`${endpoint}/publish?complaintId=${id}`, null, 'post');
	return result;
};

export const unpublishComplaint = async (id: string) => {
	const result = await makeRequest<string, null>(`${endpoint}/unpublish?complaintId=${id}`, null, 'post');
	return result;
};
